/* @ngInject */
function urlify ($sce) {
  return function (text) {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    const urlText = text.replace(urlRegex, function (url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>'
    })
    return $sce.trustAsHtml(urlText)
  }
}

export { urlify }
